import React, { Component } from "react";

import BodyMessage from "../../infra/components/PreviewMessage/BodyPreview";
import cproVideo from "../../source/cproVideo.jpg";
import cproImageCard from "../../source/cproImageCard.png";

import "./Styles.css";

class CardCarouselPreview extends Component {
  render() {
    const { templateCarousels } = this.props;
    return (
      <div className="wrapper-carousel-preview">
        {templateCarousels.map((card) => (
          <div className="card-preview">
            {card.get("format") && (
              <img
                src={
                  card.get("format").toLowerCase() === "video"
                    ? cproVideo
                    : cproImageCard
                }
                className="format-card-preview"
                alt="format-card"
              />
            )}
            <div className="card-body-preview">
              <div className="card-text-preview">
                <BodyMessage rawMessage={card.get("raw-message")} />
              </div>
              {card.get("template-buttons").map((button, i) => (
                <p
                  key={"button-card-" + i}
                  className="text-center"
                  style={{
                    backgroundColor: "#CDD7E3",
                    margin: "3px",
                    borderRadius: "5px",
                  }}
                >
                  {button.get("button-message")}
                </p>
              ))}
            </div>
          </div>
        ))}
      </div>
    );
  }
}

export default CardCarouselPreview;
